import React, { useEffect, useState } from "react";
import axios from "axios";
import CreateTrenerzyModal from "./CreateTrenerzyModal"; // Import the modal component
import EditTrenerzy from "./EditTrenerzy"; // Import the edit component
import ExceptionalHoursModal from "./ExceptionalHoursModal"; // Import the exceptional hours modal component
import ExceptionalHoursListModal from "./ExceptionalHoursListModal"; // Import the exceptional hours list modal component
import { FaEdit, FaPlus, FaTrash, FaClock } from "react-icons/fa"; // Import icons

const AllTrenerzy = () => {
  const [trenerzy, setTrenerzy] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [isCreateModalOpen, setIsCreateModalOpen] = useState(false);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [currentTrener, setCurrentTrener] = useState(null); // State for the current trainer being edited
  const [isExceptionalHoursModalOpen, setIsExceptionalHoursModalOpen] =
    useState(false); // State for the exceptional hours modal
  const [isExceptionalHoursListModalOpen, setIsExceptionalHoursListModalOpen] =
    useState(false); // State for the exceptional hours list modal
  const [currentExceptionalHours, setCurrentExceptionalHours] = useState([]); // State for the current exceptional hours
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 3; // Number of trainers per page
  const token = localStorage.getItem("token"); // Pobierz token z localStorage

  const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

  useEffect(() => {
    fetchTrenerzy();
  }, []);

  const fetchTrenerzy = async () => {
    try {
      const response = await axios.get(
        `${BACKEND_URL}/api/trenerzy/getTrenerzy`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setTrenerzy(response.data);
      setLoading(false);
    } catch (err) {
      setError("Failed to fetch trainers");
      setLoading(false);
    }
  };

  const handleCreateOrUpdateTrenerzy = async (newTrenerzy) => {
    try {
      if (currentTrener) {
        // Update existing trainer
        await axios.put(
          `${BACKEND_URL}/api/trenerzy/updateTrenerzy/${currentTrener._id}`,
          newTrenerzy,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
      } else {
        // Create new trainer
        await axios.post(
          `${BACKEND_URL}/api/trenerzy/addTrenerzy`,
          newTrenerzy,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
      }
      fetchTrenerzy(); // Refresh the list after adding or updating a trainer
      setIsCreateModalOpen(false); // Close the create modal
      setCurrentTrener(null); // Reset current trainer
    } catch (err) {
      setError("Failed to create or update trainer");
    }
  };

  const handleEditTrenerzy = (trener) => {
    setCurrentTrener(trener); // Set the current trainer to edit
    setIsEditModalOpen(true); // Open the edit modal
  };

  const handleUpdateTrenerzy = (updatedTrener) => {
    setTrenerzy((prevTrenerzy) =>
      prevTrenerzy.map((trener) =>
        trener._id === updatedTrener._id ? updatedTrener : trener
      )
    );
  };

  const handleAddExceptionalHours = async (trenerId, exceptionalHours) => {
    try {
      await axios.post(
        `${BACKEND_URL}/api/trenerzy/addWyjatkoweGodziny/${trenerId}`,
        exceptionalHours,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      fetchTrenerzy(); // Refresh the list after adding exceptional hours
      setIsExceptionalHoursModalOpen(false); // Close the modal
    } catch (err) {
      setError("Failed to add exceptional hours");
    }
  };

  const handleViewExceptionalHours = (trener) => {
    setCurrentTrener(trener);
    setCurrentExceptionalHours(trener.wyjatkowe_godziny_pracy); // Set the current exceptional hours
    setIsExceptionalHoursListModalOpen(true); // Open the exceptional hours list modal
  };

  const handleDeleteExceptionalHour = async (hourId) => {
    try {
      await axios.delete(
        `${BACKEND_URL}/api/trenerzy/deleteWyjatkoweGodziny/${currentTrener._id}`,

        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
          data: { godzinaId: hourId }, // Send the exceptional hour ID in the request body
        }
      );
      fetchTrenerzy(); // Refresh the list after deletion
    } catch (err) {
      setError("Failed to delete exceptional hour");
    }
  };

  const handleUpdateExceptionalHours = async (updatedHours) => {
    try {
      // Loop through each updated hour and send a request for each one
      await Promise.all(
        updatedHours.map(async (hour) => {
          await axios.post(
            `${BACKEND_URL}/api/trenerzy/updateWyjatkoweGodziny/${currentTrener._id}`,
            {
              godzinaId: hour._id, // Pass the specific hour ID
              data: hour.data,
              godzina_start: hour.godzina_start,
              godzina_koniec: hour.godzina_koniec,
            },
            {
              headers: {
                Authorization: `Bearer ${token}`,
              },
            }
          );
        })
      );
      fetchTrenerzy(); // Refresh the list after updating exceptional hours
    } catch (err) {
      setError("Failed to update exceptional hours");
    }
  };

  // Pagination logic
  const indexOfLastTrainer = currentPage * itemsPerPage;
  const indexOfFirstTrainer = indexOfLastTrainer - itemsPerPage;
  const currentTrainers = trenerzy.slice(
    indexOfFirstTrainer,
    indexOfLastTrainer
  );
  const totalPages = Math.ceil(trenerzy.length / itemsPerPage);

  if (loading) return <p>Loading trainers...</p>;
  if (error) return <p>{error}</p>;

  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold mb-4">Wszyscy Trenerzy</h1>
      <button
        onClick={() => {
          setCurrentTrener(null); // Reset current trainer for adding new
          setIsCreateModalOpen(true);
        }}
        className="bg-blue-500 text-white px-4 py-2 rounded mb-4 flex items-center"
      >
        <FaPlus className="mr-2" /> Dodaj Trenera
      </button>
      <table className="table-auto w-full border-collapse border border-gray-400">
        <thead>
          <tr className="bg-gray-200">
            <th className="border border-gray-400 px-4 py-2">Imię</th>
            <th className="border border-gray-400 px-4 py-2 ">Nazwisko</th>
            <th className="border border-gray-400 px-4 py-2">Email</th>
            <th className="border border-gray-400 px-4 py-2">Telefon</th>
            <th className="border border-gray-400 px-4 py-2">Godziny Pracy</th>
            <th className="border border-gray-400 px-4 py-2">Typy Treningów</th>
            <th className="border border-gray-400 px-4 py-2">Akcje</th>
          </tr>
        </thead>
        <tbody>
          {currentTrainers.map((trener) => (
            <tr key={trener._id}>
              <td className="border border-gray-400 px-4 py-2">
                {trener.imie}
              </td>
              <td className="border border-gray-400 px-4 py-2">
                {trener.nazwisko}
              </td>
              <td className="border border-gray-400 px-4 py-2">
                {trener.email}
              </td>
              <td className="border border-gray-400 px-4 py-2">
                {trener.telefon}
              </td>
              <td className="border border-gray-400 px-4 py-2">
                {trener.godziny_pracy && trener.godziny_pracy.length > 0 ? (
                  trener.godziny_pracy.map((godzina) => (
                    <div key={godzina.dzien}>
                      {godzina.dzien}: {godzina.godzina_start} -{" "}
                      {godzina.godzina_koniec}
                    </div>
                  ))
                ) : (
                  <div className="text-gray-500">Brak godzin</div>
                )}
              </td>
              <td className="border border-gray-400 px-4 py-2">
                {trener.typy_treningow && trener.typy_treningow.length > 0 ? (
                  trener.typy_treningow.map((typ, index) => (
                    <div key={index}>{typ}</div>
                  ))
                ) : (
                  <div className="text-gray-500">Brak typów</div>
                )}
              </td>
              <td className="border border-gray-400 px-4 py-2 flex flex-row h-full">
                <button
                  onClick={() => handleEditTrenerzy(trener)}
                  className="bg-yellow-500 text-white px-2 py-1 rounded flex flex-row"
                >
                  <FaEdit /> Edytuj
                </button>
                <button
                  onClick={() => handleViewExceptionalHours(trener)}
                  className="bg-blue-500 text-white px-2 py-1 rounded ml-2 flex flex-row"
                >
                  <FaClock /> Wyjątkowe Godziny
                </button>
                <button
                  onClick={() => {
                    setCurrentTrener(trener);
                    setIsExceptionalHoursModalOpen(true);
                  }}
                  className="bg-green-500 text-white px-2 py-1 rounded ml-2"
                >
                  Dodaj Wyjątkowe Godziny
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      <div className="flex justify-between mt-4">
        <button
          onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
          disabled={currentPage === 1}
          className="bg-gray-300 text-gray-700 px-4 py-2 rounded"
        >
          Poprzednia
        </button>
        <span>
          Strona {currentPage} z {totalPages}
        </span>
        <button
          onClick={() =>
            setCurrentPage((prev) => Math.min(prev + 1, totalPages))
          }
          disabled={currentPage === totalPages}
          className="bg-gray-300 text-gray-700 px-4 py-2 rounded"
        >
          Następna
        </button>
      </div>
      <CreateTrenerzyModal
        isOpen={isCreateModalOpen}
        onClose={() => setIsCreateModalOpen(false)}
        onCreate={handleCreateOrUpdateTrenerzy}
      />
      {isEditModalOpen && (
        <EditTrenerzy
          trener={currentTrener}
          onClose={() => setIsEditModalOpen(false)}
          onUpdate={handleUpdateTrenerzy}
        />
      )}
      {isExceptionalHoursModalOpen && (
        <ExceptionalHoursModal
          isOpen={isExceptionalHoursModalOpen}
          onClose={() => setIsExceptionalHoursModalOpen(false)}
          onAdd={handleAddExceptionalHours}
          trener={currentTrener}
        />
      )}
      <ExceptionalHoursListModal
        isOpen={isExceptionalHoursListModalOpen}
        onClose={() => setIsExceptionalHoursListModalOpen(false)}
        exceptionalHours={currentExceptionalHours}
        onUpdate={handleUpdateExceptionalHours}
        onDelete={handleDeleteExceptionalHour}
      />
    </div>
  );
};

export default AllTrenerzy;
